import { setSpotConfig } from '@host-panel/request/config';

export async function saveDateFormatConfig(
  spotId: string,
  value: string
) {
  return setSpotConfig(
    spotId,
    [
      {
        db: 'tenant',
        namespace: 'shared',
        key: 'date_format',
        value: value,
        expose: true,
        active: true
      }
    ]
  );
}
